"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.tooltip.view': 'Zobacz szczegóły onboardingu',
    'onboarding.tooltip.edit': 'Edytuj wpis onboardingu',
    'onboarding.tooltip.delete': 'Usuń wpis onboardingu',
};
